import { dimensionsDataSelector } from "./dimensionsDataSelector";
import { RootState } from "../../../store";

export const dimensionsDataEmptySelector = (state: RootState) => {
  const data = dimensionsDataSelector(state);

  return !data?.length;
};
